import type {RepositoryDataResponse} from '@github-ui/data-router-error-helpers'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {IssueRepoNewChoosePageQuery} from '@github-ui/server-persisted-queries'
import type {IssueRepoNewChoosePageQueryQuery} from '@github-ui/server-persisted-queries/types/IssueRepoNewChoosePageQuery'

import {repoRouteBuilder} from '../config/repo-route-builder'

// RepositoryDataResponse exposes the errors array so handleRepositoryDataError can detect FORBIDDEN/SAML.
export type IssueNewChoosePayload = RepositoryDataResponse<IssueRepoNewChoosePageQueryQuery>

export function buildIssueNewChooseRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('issueNewChooseRoute', {
    path: '/:owner/:repo/issues/new/choose',
    queries: [
      mainQuery<IssueNewChoosePayload>({
        // owner/name are resolved from the pathname by the BFF, so we only
        // need to forward the pathname and the persisted-query id.
        queryDeps: ({pathname}) => ({
          pathname,
          searchParams: {
            queryId: IssueRepoNewChoosePageQuery,
          },
        }),
      }),
    ],
  })
}

export const issueNewChooseRoute = buildIssueNewChooseRoute(repoRouteBuilder)
